import React, { useCallback, useState } from 'react'
import _ from 'lodash'

import CustomDropdown from '../../../widgets/custom_dropdown'
import { ApiHelper } from '../../../../helpers/apihelper'
import { SYSTEM_PROPERTY_OPTIONS } from './helper/constants'
import DeduplicationCache from './sysprop/deduplication_cache'

const UpdateSystemProperties = ({ client }) => {
  const [selectedProperty, setSelectedProperty] = useState(SYSTEM_PROPERTY_OPTIONS[0])

  // Check (read) the current value of a system property by name.
  const checkSystemProperty = useCallback((name) => {
    const body = _.pick({ name }, ApiHelper(client, 'CHECK_SYSTEM_PROPERTY').API_BODY)
    return ApiHelper(client, 'CHECK_SYSTEM_PROPERTY').API(client, body)
  }, [client])

  // Update a system property. requestBody should contain { name, value, desc }.
  // `upsert` is hardcoded to 'crm' to tag the change source as this CRM tool.
  const updateSystemProperty = useCallback((requestBody) => {
    const body = _.pick({ ...requestBody, upsert: 'crm' }, ApiHelper(client, 'UPDATE_SYSTEM_PROPERTY').API_BODY)
    return ApiHelper(client, 'UPDATE_SYSTEM_PROPERTY').API(client, body)
  }, [client])

  const renderProperty = (value) => {
    switch (value) {
      case 'deduplication_cache':
        return (
          <DeduplicationCache
            onCheck={checkSystemProperty}
            onUpdate={updateSystemProperty}
          />
        )
      default:
        return null
    }
  }

  return (
    <>
      <div className='mis-wrapper dedup-cache-wrapper update-sysprop-select'>
        <div className='w-100'>
          <label className='mb-1'>System Property:</label>
          <CustomDropdown
            name='system_property'
            options={SYSTEM_PROPERTY_OPTIONS}
            placeholder='Select a system property'
            value={selectedProperty}
            onSelectOption={(option) => setSelectedProperty(option)}
            searchable={true}
          />
        </div>
      </div>
      {renderProperty(selectedProperty.value)}
    </>
  )
}

export default UpdateSystemProperties
